export default {
    "graphqlEndpoint": "https://bqr6vrskmrclrl4bzbrbdsxgj4.appsync-api.us-east-2.amazonaws.com/graphql",
    "region": "us-east-2",
    "authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "apiKey": "null"
}


// WEBPACK FOOTER //
// ./src/AppSync.js